import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SignIn from "./pages/AuthPages/SignIn";
import SignUp from "./pages/AuthPages/SignUp";
import NotFound from "./pages/OtherPage/NotFound";
import Unauthorized from "./pages/OtherPage/Unauthorized";
import UserProfiles from "./pages/UserProfiles";
import AppLayout from "./layout/AppLayout";
import CustomerLayout from "./layout/CustomerLayout";
import { ScrollToTop } from "./components/common/ScrollToTop";
import Home from "./pages/Dashboard/Home";
import PrivateRoute from "./pages/AuthPages/privateRoute";
import ManageWallet from "./pages/wallet/manageWallet";
import StockTransferToDownlineAgents from "./pages/wallet/stockTransferToDownlineAgents";
import ManageAgent from "./pages/agentManagement/manageAgent";
// import RollbackOperation from "./pages/RollbackOperation";
import ProductList from "./pages/Products/productList";
import GameList from "./pages/Products/gameList";
import Recharge from "./pages/Products/RechargeTopup";
import ProductActivation from "./pages/Reports/TransactionReport";
import StockOutInReport from "./pages/Reports/stockOut-inReport";
import DownlineReport from "./pages/Reports/downlineReport";
import TopupRechargeReport from "./pages/Reports/topupRechargeReport";
import DownlineProductActivation from "./pages/Reports/downlineProductActivation";
import DownlineRechargeReport from "./pages/Reports/downlineRechargeReport";
import PurchaseStock from "./pages/Stock/PurchaseStock";
import RequestToReverse from "./pages/Stock/RequestToReverseStock";
import TicketManagement from "./pages/TicketManagement";
import Statement from "./pages/Statement";
import AgentProfile from "./pages/agentManagement/manageAgent/components/AgentDetails";
import EditAgent from "./pages/agentManagement/manageAgent/components/EditAgent";
import Orders from "./pages/Order";
import ComingSoon from "./components/coming-soon";
import CustomerHome from "./pages/Dashboard/CustomerHome";
import OrdersC from "./pages/OrderC";
import firebaseNotificationService from './services/firebaseNotificationService';
import CustomerTicketsPage from "./pages/customerTicketMangment";
import ManageSlabs from "./pages/slabManagment";
import AgentRollbackReports from "./pages/agentRollbackReport";
import MerchantApiUAT from "./pages/MerchantApiUAT/MerchantApiUAT";
import BulkStockTransfer from "./pages/bulkStockTransfer";
import BulkRecharge from "./pages/bulkRecharge";
import SocialProductsList from "./pages/Products/socialList/SocialProductList";
import SocialActivation from "./pages/Products/socialList/SocialActivationList";
import BundleActivation from "./pages/Products/productList";
import { useEffect } from "react";
import GameActivation from "./pages/Products/GameActivation";
import AboutUs from "./pages/aboutUs";
import ContactUs from "./pages/contactUs";
import PrivacyPolicy from "./pages/privacyPolicy";
import TermsAndConditions from "./pages/termAndCondition";
import ProductsList from "./pages/Products/ProductsList";



// import CustomerDashboard from "./pages/Customer/Dashboard";
// import CustomerOrders from "./pages/Customer/Orders";
// import CustomerWallet from "./pages/Customer/Wallet";
// import CustomerProfile from "./pages/Customer/Profile";
// import CustomerSupport from "./pages/Customer/Support";

export default function App() {
  useEffect(() => {
    const setupNotifications = async () => {
      setTimeout(async () => {
        const token = localStorage.getItem('token');
        const userStr = localStorage.getItem('user');

        if (token && userStr) {
          try {
            const user = JSON.parse(userStr);
            console.log('🔔 App.jsx - Setting up notifications for user:', user.id);


          } catch (error) {
            console.error('Error setting up notifications:', error);
          }
        }
      }, 2000);
    };

    setupNotifications();
  }, []);
  return (
    <>
      <Router >
        <ScrollToTop />
        <Routes>
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/unauthorized" element={<Unauthorized />} />


          <Route element={<PrivateRoute allowedRoles={["merchant", "retailer", "b2b", "business"]} />}>
            <Route element={<AppLayout />}>
              <Route index element={<Home />} />
              <Route path="/profile" element={<UserProfiles />} />
              <Route path="/manage-wallet" element={<ManageWallet />} />
              <Route path="/product-list" element={<BundleActivation />} />
              <Route path="/products" element={<ProductsList />} />
              <Route path="/game-list" element={<GameList />} />
              <Route path="/social-list" element={<SocialProductsList />} />
              <Route path="/social-list/activate/:productId" element={<SocialActivation />} />
              <Route path="/slabs" element={<ManageSlabs />} />
              <Route path="/recharge" element={<Recharge />} />
              <Route path="/order" element={<Orders />} />
              <Route path="/ticket-management" element={<TicketManagement />} />
              <Route path="/request-reverse" element={<RequestToReverse />} />
              <Route path="/merchant-api-uat" element={<MerchantApiUAT />} />
              <Route path="/statment" element={<Statement />} />
              <Route path="/gameActivation" element={<GameActivation />} />
              <Route path="/AboutUs" element={<AboutUs />} />
              <Route path="/ContactUs" element={<ContactUs />} />
              <Route path="/Privacy" element={<PrivacyPolicy />} />
              <Route path="/TermAndCondition" element={<TermsAndConditions />} />

              <Route
                path="/stock-transfer-downline"
                element={
                  <PrivateRoute allowedRoles={["merchant"]}>
                    <StockTransferToDownlineAgents />
                  </PrivateRoute>
                }
              />
              <Route
                path="/purchase-stock"
                element={
                  <PrivateRoute allowedRoles={["merchant"]}>
                    <PurchaseStock />
                  </PrivateRoute>
                }
              />
              <Route
                path="/manage-agent"
                element={
                  <PrivateRoute allowedRoles={["merchant"]}>
                    <ManageAgent />
                  </PrivateRoute>
                }
              />
              <Route
                path="/agent-profile/:id"
                element={
                  <PrivateRoute allowedRoles={["merchant"]}>
                    <AgentProfile />
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-agent/:id"
                element={
                  <PrivateRoute allowedRoles={["merchant"]}>
                    <EditAgent />
                  </PrivateRoute>
                }
              />
              {/* <Route 
                path="/rollback-operation" 
                element={
                  <PrivateRoute allowedRoles={["merchant", "retailer"]}>
                    <RollbackOperation />
                  </PrivateRoute>
                } 
              /> */}

              <Route
                path="/agentRollbackReport"
                element={
                  <PrivateRoute allowedRoles={["merchant", "retailer"]}>
                    <AgentRollbackReports />
                  </PrivateRoute>
                }
              />
              <Route
                path="/bulkStockTransfer"
                element={
                  <PrivateRoute allowedRoles={["merchant"]}>
                    <BulkStockTransfer />
                  </PrivateRoute>
                }
              />
              <Route
                path="/bulkRecharge"
                element={
                  <PrivateRoute allowedRoles={["merchant", "retailer"]}>
                    <BulkRecharge />
                  </PrivateRoute>
                }
              />
              <Route
                path="/transaction-report"
                element={
                  <PrivateRoute allowedRoles={["merchant", "retailer"]}>
                    <ProductActivation />
                  </PrivateRoute>
                }
              />
              <Route
                path="/stock-out-in-report"
                element={
                  <PrivateRoute allowedRoles={["merchant", "retailer"]}>
                    <StockOutInReport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/downline-product-activation"
                element={
                  <PrivateRoute allowedRoles={["merchant", "retailer"]}>
                    <DownlineProductActivation />
                  </PrivateRoute>
                }
              />
              <Route
                path="/downline-recharge-report"
                element={
                  <PrivateRoute allowedRoles={["merchant", "retailer"]}>
                    <DownlineRechargeReport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/downline-report"
                element={
                  <PrivateRoute allowedRoles={["merchant", "retailer"]}>
                    <DownlineReport />
                  </PrivateRoute>
                }
              />

              <Route
                path="/topup-report"
                element={
                  <PrivateRoute allowedRoles={["merchant", "retailer"]}>
                    <TopupRechargeReport />
                  </PrivateRoute>
                }
              />
            </Route>
          </Route>


          <Route element={<PrivateRoute allowedRoles={["b2c"]} />}>
            <Route element={<CustomerLayout />}>
              {/* <Route path="/coming-soon" element={<ComingSoon />} /> */}
              <Route path="/Customer-dashboard" element={<CustomerHome />} />
              <Route path="/Customer-order" element={<OrdersC />} />
              <Route path="/customer-profile" element={<AgentProfile />} />
              <Route path="/customer-support" element={<CustomerTicketsPage />} />
            </Route>
          </Route>


          <Route path="/" element={<RootRedirector />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}


const RootRedirector = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);

  const userAccountType = user?.agentDetail?.accountType;
  const userRole = user?.roleData?.name || "b2c";
  const effectiveRole = userAccountType ? userAccountType : userRole;

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  if (effectiveRole === "merchant" || effectiveRole === "retailer") {
    return <Navigate to="/" replace />;
  } else if (effectiveRole === "b2c") {
    return <Navigate to="/Customer-dashboard" replace />;
  } else {
    return <Navigate to="/signin" replace />;
  }
};